<template>
  <v-container>
    <PageTitle icon="mdi-clock-time-four" main="Carga Horária" sub=""/>

    <!-- Painel de Estatísticas -->
    <v-row class="mb-4">
      <v-col cols="12" md="4">
        <div class="stats-card">
          <div class="stats-number">{{ cargahoraria.length }}</div>
          <div class="stats-label">Colaboradores</div>
        </div>
      </v-col>
      <v-col cols="12" md="4">
        <div class="stats-card">
          <div class="stats-number">{{ getHorasEsperadasDoMes() }}</div>
          <div class="stats-label">Horas Esperadas do Mês</div>
        </div>
      </v-col>
      <v-col cols="12" md="4">
        <div class="stats-card">
          <div class="stats-number">{{ getAusenciasTotal() }}</div>
          <div class="stats-label">Ausências</div>
        </div>
      </v-col>
    </v-row>

    <!-- Tabela Principal -->
    <v-card flat class="professional-card">
      <v-card-title class="professional-header d-flex align-center">
        <div class="d-flex align-center">
          <v-icon left color="grey darken-2" small>mdi-table</v-icon>
          Relatório de Carga Horária
        </div>

        <v-spacer></v-spacer>

        <!-- ✅ Seletor de mês -->
        <v-menu
        v-model="menuMes"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="290px"
        >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
          v-model="mesSelecionado"
          outlined
          dense
          readonly
          hide-details
          label="Mês"
          prepend-inner-icon="mdi-calendar-month"
          style="max-width: 220px;"
          v-bind="attrs"
          v-on="on"
          />
        </template>

        <v-date-picker
        v-model="mesSelecionado"
        type="month"
        locale="pt-br"
        @change="menuMes = false; onChangeMes()"
        />
      </v-menu>
    </v-card-title>

    <v-divider></v-divider>

    <v-data-table
    :items="cargahoraria"
    :items-per-page="-1"
    :headers="table"
    :expanded.sync="expanded"
    :single-expand="true"
    item-key="idfuncionarios"
    show-expand
    hide-default-footer
    class="elevation-0"
    >
    <template v-slot:item.data-table-expand="{ expand, isExpanded }">
      <v-btn icon small @click="expand(!isExpanded)">
        <v-icon small color="grey darken-2">
          {{ isExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
        </v-icon>
      </v-btn>
    </template>
    <template v-slot:item.status_resumo="{ item }">
      <div class="d-flex align-center">
        <v-chip
        v-if="item.temFerias"
        small
        color="blue lighten-4"
        class="blue--text text--darken-3"
        outlined
        label
        >
        <v-icon left small color="blue darken-2">mdi-beach</v-icon>
        Férias
        <span v-if="item.diasFerias">({{ item.diasFerias }})</span>
      </v-chip>

      <span v-else class="grey--text text--darken-1">—</span>
    </div>
  </template>

  <template v-slot:expanded-item="{ item }">
    <td :colspan="table.length + 1" class="pa-0">
      <v-card flat class="expanded-content">
        <v-card-title class="professional-subheader">
          <v-icon left small color="grey darken-2">mdi-history</v-icon>
          Detalhamento de Pontos
        </v-card-title>
        <v-divider></v-divider>

        <v-data-table
        :items="item.horarios"
        :headers="table2"
        hide-default-footer
        disable-pagination
        class="elevation-0"
        >
        <template v-slot:item="{ item: row }">
          <tr
          :class="row.dia_semana && row.dia_semana === 'Dom'
          ? 'domingo-row'
          : row.dia_semana !== 'Dom' && row.status === 'Compensada'
          ? 'folga-row'
          : ''"
          >
          <td v-for="(h, index) in table2" :key="index">

            <!-- Entrada -->
            <template v-if="h.value === 'entrada'">
              <v-btn
              text small class="text-body-2"
              @click="loadCampo(row.idexpediente, row.entrada,'entrada', row)"
              :disabled="!row.idexpediente"
              >
              {{ row.entrada || '--:--' }}
            </v-btn>
          </template>

          <!-- Saída almoço -->
          <template v-else-if="h.value === 'saida_almoco'">
            <v-btn
            text small class="text-body-2"
            @click="loadCampo(row.idexpediente, row.saida_almoco, 'saida_almoco', row)"
            :disabled="!row.idexpediente"
            >
            {{ row.saida_almoco || '--:--' }}
          </v-btn>
        </template>

        <!-- Retorno -->
        <template v-else-if="h.value === 'retorno'">
          <v-btn
          text small class="text-body-2"
          @click="loadCampo(row.idexpediente, row.retorno, 'retorno', row)"
          :disabled="!row.idexpediente"
          >
          {{ row.retorno || '--:--' }}
        </v-btn>
      </template>

      <!-- Saída -->
      <template v-else-if="h.value === 'saida'">
        <v-btn
        text small class="text-body-2"
        @click="loadCampo(row.idexpediente, row.saida, 'saida', row)"
        :disabled="!row.idexpediente"
        >
        {{ row.saida || '--:--' }}
      </v-btn>
    </template>
    <!-- Entrada Extra -->
    <template v-else-if="h.value === 'extra_entrada'">
      <v-btn
      text small class="text-body-2"
      @click="loadCampo(row.idexpediente, row.extra_entrada, 'extra_entrada', row)"
      :disabled="!row.idexpediente"
      >
      {{ row.extra_entrada || '--:--' }}
    </v-btn>
  </template>
  <!-- Saída Extra-->
  <template v-else-if="h.value === 'extra_saida'">
    <v-btn
    text small class="text-body-2"
    @click="loadCampo(row.idexpediente, row.extra_saida, 'extra_saida', row)"
    :disabled="!row.idexpediente"
    >
    {{ row.extra_saida || '--:--' }}
  </v-btn>
</template>

<!-- Horas trabalhadas -->
<template v-else-if="h.value === 'horas_trabalhadas'">
  <div class="text-body-2 font-weight-medium" v-if="row.dia_semana === 'Dom'">
    Domingo
  </div>
  <div class="text-body-2 font-weight-medium" v-else-if="row.status === 'Férias' || row.motivo === 'Férias'">
    Férias
  </div>
  <div class="text-body-2 font-weight-medium" v-else-if="row.dia_semana !== 'Dom' && row.status === 'Compensada'">
    {{ row.motivo }}
  </div>
  <div class="text-body-2 font-weight-medium" v-else>
    {{ row.horas_trabalhadas }}
  </div>
</template>

<!-- Chip Editado -->
<template v-else-if="h.value === 'editado'">
  <v-chip
  v-if="row.editado"
  small
  color="amber lighten-4"
  class="amber--text text--darken-3"
  outlined
  >
  Editado
</v-chip>
<span v-else class="grey--text text--darken-1">—</span>
</template>

<!-- Tooltip de edição -->
<template v-else-if="h.value === 'edicao_info'">
  <div v-if="row.editado" class="d-flex align-center">
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-icon small color="amber darken-2" v-bind="attrs" v-on="on">
          mdi-alert-circle-outline
        </v-icon>
      </template>

      <div class="text-caption">
        <div><strong>Editado manualmente</strong></div>
        <div>Por: {{ row.editado_por || row.editado_por_id || '—' }}</div>
        <div>Em: {{ formatarDataHora(row.editado_em) }}</div>
        <div style="max-width: 360px; white-space: normal;">
          {{ row.editado_justificativa || '—' }}
        </div>
      </div>
    </v-tooltip>
  </div>
  <span v-else class="grey--text text--darken-1">—</span>
</template>

<!-- Ações -->
<template v-else-if="h.value === 'actions'">
  <template v-if="user.tipo === 'Gerente' || user.tipo === 'Admin' || user.tipo === 'Master' || user.tipo === 'Coordenador' || user.tipo === 'Financeiro'">
    <v-btn icon small @click="loadTodosCampos(row)">
      <v-icon small color="grey darken-2">mdi-pencil</v-icon>
    </v-btn>
  </template>
</template>

<!-- Padrão -->
<template v-else>
  {{ row[h.value] }}
</template>

</td>
</tr>
</template>
</v-data-table>

<!-- Ausências -->
<div v-if="ausencias && ausencias.length" class="mt-4">
  <v-card-title class="professional-subheader">
    <v-icon left small color="grey darken-2">mdi-alert-circle</v-icon>
    Ausências
  </v-card-title>
  <v-divider></v-divider>

  <!-- Painel de Busca -->
  <v-card flat class="professional-card mb-4">
    <v-card-title class="professional-header">
      <v-icon left color="grey darken-2" small>mdi-magnify</v-icon>
      Buscar Expedientes por Data
    </v-card-title>
    <v-divider></v-divider>

    <v-card-text class="pa-4">
      <v-row dense>
        <v-col cols="12" md="5">
          <v-autocomplete
          v-model="filtro.idfunc"
          :items="colaboradores"
          item-text="nome"
          item-value="idfuncionarios"
          outlined
          dense
          clearable
          label="Colaborador"
          prepend-inner-icon="mdi-account"
          />
        </v-col>

        <v-col cols="12" md="3">
          <v-text-field
          v-model="filtro.inicio"
          type="date"
          outlined
          dense
          label="Data início"
          prepend-inner-icon="mdi-calendar-start"
          />
        </v-col>

        <v-col cols="12" md="3">
          <v-text-field
          v-model="filtro.fim"
          type="date"
          outlined
          dense
          label="Data fim"
          prepend-inner-icon="mdi-calendar-end"
          />
        </v-col>

        <v-col cols="12" md="1" class="d-flex align-center justify-end">
          <v-btn
          color="grey darken-3"
          dark
          :loading="loadingBusca"
          @click="buscarExpedientes"
          >
          Buscar
        </v-btn>
      </v-col>
    </v-row>

    <v-alert v-if="erroBusca" type="error" dense text class="mt-3">
      {{ erroBusca }}
    </v-alert>
  </v-card-text>
</v-card>

<!-- Resultados -->
<v-card flat class="professional-card">
  <v-card-title class="professional-header d-flex align-center">
    <v-icon left color="grey darken-2" small>mdi-table</v-icon>
    Resultados
    <v-spacer></v-spacer>
    <v-chip small outlined>{{ resultados.length }} registros</v-chip>
  </v-card-title>
  <v-divider></v-divider>

  <v-data-table
  :items="resultados"
  :headers="headersResultados"
  class="elevation-0"
  :loading="loadingBusca"
  loading-text="Buscando..."
  item-key="key"
  >
  <template v-slot:item.data="{ item }">
    {{ formatoData(item.data) }}
  </template>

  <template v-slot:item.actions="{ item }">
    <template v-if="user.tipo === 'Gerente' || user.tipo === 'Admin' || user.tipo === 'Master' || user.tipo === 'Coordenador' || user.tipo === 'Financeiro'">
      <v-btn icon small @click="loadTodosCampos(item)">
        <v-icon small color="grey darken-2">mdi-pencil</v-icon>
      </v-btn>
    </template>
  </template>
</v-data-table>
</v-card>
</div>
</v-card>
</td>
</template>
</v-data-table>
</v-card>

<!-- Diálogo de Justificativa -->
<v-dialog v-model="dialogoJustificativa" max-width="600px">
  <v-card class="professional-dialog">
    <v-card-title class="professional-dialog-header">
      <v-icon left color="white" small>mdi-text-box</v-icon>
      Justificativa de Ausência
    </v-card-title>
    <v-card-text class="pa-6">
      <v-row>
        <v-col>
          <v-autocomplete
          :items="motivo"
          v-model="texto.motivo"
          label="Motivo"
          outlined
          dense
          required
          />
          <v-textarea
          v-if="texto.motivo && texto.motivo !== 'Normal'"
          v-model="texto.descricao"
          label="Justificativa"
          rows="4"
          outlined
          dense
          required
          />
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions class="pa-4">
      <v-spacer></v-spacer>
      <v-btn text color="grey darken-1" @click="dialogoJustificativa = false">Cancelar</v-btn>
      <v-btn color="grey darken-3" dark @click="salvarJustificativa">Salvar</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

<!-- Dialog Campo -->
<v-dialog v-model="dialogCampo" max-width="400">
  <v-card class="professional-dialog">
    <v-card-title class="professional-dialog-header">
      <v-icon left color="white" small>mdi-clock-edit</v-icon>
      Editar Horário
    </v-card-title>
    <v-card-text class="pa-6">
      <v-alert v-if="editponto && editponto.editado" type="warning" dense text class="mb-3">
        <div class="text-caption">
          <div><strong>Este expediente já foi editado.</strong></div>
          <div>Por: {{ editponto.editado_por || '—' }}</div>
          <div>Em: {{ editponto.editado_em || '—' }}</div>
          <div style="white-space: normal;">
            Justificativa: {{ editponto.editado_justificativa || '—' }}
          </div>
        </div>
      </v-alert>

      <v-text-field
      type="text"
      v-model="editponto.campo"
      v-mask="['##:##']"
      outlined
      dense
      label="Horário"
      placeholder="00:00"
      />

      <v-textarea
      v-model="editJustificativa"
      outlined
      dense
      rows="3"
      auto-grow
      label="Justificativa da edição (obrigatória)"
      prepend-inner-icon="mdi-text-box"
      class="mt-2"
      />

      <v-alert v-if="erroEdicao" type="error" dense text class="mt-3">
        {{ erroEdicao }}
      </v-alert>
    </v-card-text>

    <v-card-actions class="pa-4">
      <v-spacer></v-spacer>
      <v-btn text color="grey darken-1" @click="reset">Cancelar</v-btn>
      <v-btn color="grey darken-3" dark :disabled="!podeSalvarEdicao" @click="save">Salvar</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

<!-- Dialog Todos Campos -->
<v-dialog v-model="dialogEditarCampos" max-width="800">
  <v-card class="professional-dialog">
    <v-card-title class="professional-dialog-header">
      <v-icon left color="white" small>mdi-clock-edit-outline</v-icon>
      Editar Todos os Pontos
    </v-card-title>
    <v-card-text class="pa-6">
      <v-row>
        <v-col cols="6" md="3">
          <v-text-field label="Entrada" type="text" v-model="editcampos.entrada" v-mask="['##:##']" outlined dense placeholder="00:00" />
        </v-col>
        <v-col cols="6" md="3">
          <v-text-field label="Saída Almoço" type="text" v-model="editcampos.saida_almoco" v-mask="['##:##']" outlined dense placeholder="00:00" />
        </v-col>
        <v-col cols="6" md="3">
          <v-text-field label="Retorno" type="text" v-model="editcampos.retorno" v-mask="['##:##']" outlined dense placeholder="00:00" />
        </v-col>
        <v-col cols="6" md="3">
          <v-text-field label="Saída" type="text" v-model="editcampos.saida" v-mask="['##:##']" outlined dense placeholder="00:00" />
        </v-col>
        <v-col cols="6" md="3">
          <v-text-field label="Entrada Extra" type="text" v-model="editcampos.extra_entrada" v-mask="['##:##']" outlined dense placeholder="00:00" />
        </v-col>
        <v-col cols="6" md="3">
          <v-text-field label="Saída Extra" type="text" v-model="editcampos.extra_saida" v-mask="['##:##']" outlined dense placeholder="00:00" />
        </v-col>
      </v-row>

      <v-alert v-if="editcampos && editcampos.editado" type="warning" dense text class="mb-3">
        <div class="text-caption">
          <div><strong>Este expediente já foi editado.</strong></div>
          <div>Por: {{ editcampos.editado_por || '—' }}</div>
          <div>Em: {{ editcampos.editado_em || '—' }}</div>
          <div style="white-space: normal;">
            Justificativa: {{ editcampos.editado_justificativa || '—' }}
          </div>
        </div>
      </v-alert>

      <v-textarea
      v-model="editJustificativa"
      outlined
      dense
      rows="3"
      auto-grow
      label="Justificativa da edição (obrigatória)"
      prepend-inner-icon="mdi-text-box"
      class="mt-2"
      />

      <v-alert v-if="erroEdicao" type="error" dense text class="mt-3">
        {{ erroEdicao }}
      </v-alert>
    </v-card-text>

    <v-card-actions class="pa-4">
      <v-spacer></v-spacer>
      <v-btn text color="grey darken-1" @click="reset">Cancelar</v-btn>
      <v-btn color="grey darken-3" dark :disabled="!podeSalvarEdicao" @click="save">Salvar</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</v-container>
</template>


<script>
import PageTitle from '@/templates/PageTitle'
import axios from 'axios'
import { baseApiUrl, showError } from '@/global'
import moment from 'moment'
import { mapState } from 'vuex'

export default {
  name: 'CargaHoraria',
  components: { PageTitle },
  data () {
    return {
      editJustificativa: '',
      erroEdicao: '',
      ausencias: [],
      detalhes: false,
      informacoes: {},
      expanded: [],
      cargahoraria: [],
      editponto: {},
      editcampos: {},
      dialogoJustificativa: false,
      dialogEditarCampos: false,
      dialogCampo: false,
      texto: {},
      justificativaItem: null,

      // ✅ NOVO: mês selecionado
      menuMes: false,
      mesSelecionado: moment().format('YYYY-MM'),

      table: [
        { text: 'Id', value: 'idfuncionarios' },
        { text: 'Nome', value: 'nome' },
        { text: 'Status', value: 'status_resumo', sortable: false },
        // { text: 'Img', value: 'usuario' },
        { text: 'Cod Vendedor', value: 'cod_vendedor' },
        { text: 'Cod PDV', value: 'cod_pdv' }
        ],
      table2: [
        { text: 'Id', value: 'idexpediente' },
        { text: 'Data', value: 'data' },
        { text: 'Entrada', value: 'entrada' },
        { text: 'Saída Almoço', value: 'saida_almoco' },
        { text: 'Retorno', value: 'retorno' },
        { text: 'Saída', value: 'saida' },
        { text: 'Entrada Extra', value: 'extra_entrada' },
        { text: 'Saída Extra', value: 'extra_saida' },
        { text: 'Horas Trabalhadas', value: 'horas_trabalhadas' },
        { text: '', value: 'actions' }
        ],
      motivo: [
        { text: 'Hora Extra', value: 'Hora Extra' },
        { text: 'Atraso', value: 'Atraso' },
        { text: 'Ausência', value: 'Ausencia' },
        { text: 'Justificado', value: 'Justificado' }
        ],
      tableAusencias: [
        { text: 'Id', value: 'idausencias' },
        { text: 'Data', value: 'data' },
        { text: 'Motivo', value: 'motivo' },
        { text: 'Ações/Justificativas', value: 'actions' }
        ],

      filtro: {
        idfunc: null,
        inicio: moment().startOf('month').format('YYYY-MM-DD'),
        fim: moment().endOf('month').format('YYYY-MM-DD')
      },
      loadingBusca: false,
      erroBusca: '',
      resultados: [],
      colaboradores: [],
      headersResultados: [
        { text: 'Colaborador', value: 'nome' },
        { text: 'Data', value: 'data' },
        { text: 'Entrada', value: 'entrada' },
        { text: 'Saída Almoço', value: 'saida_almoco' },
        { text: 'Retorno', value: 'retorno' },
        { text: 'Saída', value: 'saida' },
        { text: 'Entrada Extra', value: 'extra_entrada' },
        { text: 'Saída Extra', value: 'extra_saida' },
        { text: 'Horas', value: 'horas_trabalhadas' },
        { text: "Editado", value: "editado" },
        { text: "Edição", value: "edicao_info" },
        { text: '', value: 'actions', sortable: false, width: 60 }
        ]
    }
  },
  computed: {
    ...mapState(['user']),

    podeEditarPonto () {
      return this.user?.perm_editar_ponto === 1 ||
      this.user?.perm_editar_ponto === true ||
      this.user?.perm_editar_ponto === '1'
    },

    podeSalvarEdicao () {
      return !!String(this.editJustificativa || '').trim()
    }
  },
  methods: {
  // ✅ Mantém a Carga Horária exibindo apenas colaboradores ativos.
  // Se o backend ainda não devolver status no /pontos, não bloqueia o registro por segurança.
    isUsuarioAtivo (f = {}) {
      const status = f.status ?? f.usuario_status ?? f.status_usuario ?? f.ativo
      if (status === undefined || status === null || status === '') 
        return true
        return status === true || status === 1 || status === '1' || String(status).toLowerCase() === 'ativo'
    },

    // ✅ NOVO: ao trocar mês, recarrega
    onChangeMes () {
      // opcional: você pode também ajustar filtro.inicio/fim para o mesmo mês selecionado
      // sem mexer no seu fluxo atual, só recarregamos a tabela principal
      this.expanded = []
      this.loadCargaHoraria()
    },

    getHorasEsperadasDoMes () {
      const cargaHorariaDiaria = this.user?.carga_horaria || 8

      const hoje = moment()
      const primeiroDia = hoje.clone().startOf('month')
      const ultimoDia = hoje.clone().endOf('month')

      let horasEsperadas = 0
      let dia = primeiroDia.clone()

      while (dia.isSameOrBefore(ultimoDia, 'day')) {
        const diaSemana = dia.day()

        if (diaSemana >= 1 && diaSemana <= 5) {
          horasEsperadas += cargaHorariaDiaria
        } else if (diaSemana === 6) {
          horasEsperadas += cargaHorariaDiaria / 2
        }
        dia.add(1, 'day')
      }

      return horasEsperadas.toFixed(0)
    },

    getAusenciasTotal () {
      return this.ausencias ? this.ausencias.length : 0
    },

    // ✅ ALTERADO: agora envia ano/mes para backend
    loadCargaHoraria () {
      const [ano, mes] = String(this.mesSelecionado || '').split('-')
      axios.get(`${baseApiUrl}/pontos`, {
        params: { ano, mes, status: 'ativos' }
      })
      .then(res => {
        this.cargahoraria = (res.data || [])
        .filter(this.isUsuarioAtivo)
        .map(f => {
          const horarios = (f.horarios || []).map(h => {
      // ... seu map atual exatamente como está
            if (h.tipo) {
              return {
                horas_trabalhadas: h.horastrabalhadas?.cargaHoraria || h.horastrabalhadas,
                tipo: h.tipo,
                status: h.status,
                cor: h.cor,
                dia_semana: h.dia_semana,
                idfuncionarios: f.idfuncionarios
              }
            } else {
              return {
                idexpediente: h.idexpedientes,
                data: this.formatoData(h.data),
                entrada: h.entrada,
                saida_almoco: h.saida_almoco,
                retorno: h.retorno,
                saida: h.saida,
                extra_entrada: h.extra_entrada,
                extra_saida: h.extra_saida,
                horas_trabalhadas: h.horastrabalhadas || this.formatoHoras(0),
                carga_horaria_diaria: h.carga_horaria_diaria,
                motivo: h.motivo,
                descricao: h.descricao,
                tipo: h.tipo,
                status: h.status,
                dia_semana: h.dia_semana,
                cor: h.cor,
                statusIcon: h.statusIcon,
                statusIcon2: h.statusIcon2,
                progress: h.progress,
                editado: !!h.editado,
                editado_em: h.editado_em,
                editado_por: h.editado_por,
                editado_por_id: h.editado_por_id,
                editado_justificativa: h.editado_justificativa,
                editado_manualmente: !!h.editado_manualmente,
                idfuncionarios: f.idfuncionarios
              }
            }
          })

    // ✅ DETECTA FÉRIAS (por status OU motivo)
          const feriasList = horarios.filter(x =>
            String(x.status || '').toLowerCase() === 'férias'.toLowerCase() ||
            String(x.status || '').toLowerCase() === 'ferias' ||
            String(x.motivo || '').toLowerCase() === 'férias'.toLowerCase() ||
            String(x.motivo || '').toLowerCase() === 'ferias'
            )

          return {
            idfuncionarios: f.idfuncionarios,
            nome: f.nome,
            usuario: f.usuario,
            cod_vendedor: f.cod_vendedor,
            cod_pdv: f.cod_pdv,
            ausencias: f.ausencias,

      // ✅ NOVO: resumo
            temFerias: feriasList.length > 0,
            diasFerias: feriasList.length,

            horarios
          }
        })
      }).catch(showError)
    },

    loadCampo(id, item, nome, row = {}) {
      this.dialogCampo = true
      this.erroEdicao = ''
      this.editJustificativa = ''

      this.editponto = {
        nome,
        idexpediente: id,
        campo: item,

    // se seu backend já devolve isso no /pontos (mês), vai mostrar no alerta
        editado: !!row.editado,
        editado_em: row.editado_em,
        editado_por: row.editado_por,
        editado_justificativa: row.editado_justificativa
      }
    },


    loadTodosCampos(item) {
      this.dialogEditarCampos = true
      this.erroEdicao = ''
      this.editJustificativa = ''

      this.editcampos = {
        campos: 'campos',
        idexpediente: item.idexpediente,
        entrada: item.entrada,
        saida_almoco: item.saida_almoco,
        retorno: item.retorno,
        saida: item.saida,
        extra_entrada: item.extra_entrada,
        extra_saida: item.extra_saida,
        idfuncionarios: item.idfuncionarios,
        data: moment(item.data, ['DD/MM/YYYY','YYYY-MM-DD', moment.ISO_8601]).format('YYYY-MM-DD'),

        editado: !!item.editado,
        editado_em: item.editado_em,
        editado_por: item.editado_por,
        editado_justificativa: item.editado_justificativa
      }
    },


    loadAusencias () {
      axios.get(`${baseApiUrl}/ausencias`).then(res => {
        this.ausencias = res.data
      })
    },

    loadDetalhes (item) {
      this.detalhes = true
      this.informacoes = item
    },

    loadColaboradores () {
      axios.get(`${baseApiUrl}/pontos`, {
        params: { status: 'ativos' }
      })
      .then(res => {
        this.colaboradores = (res.data || [])
        .filter(this.isUsuarioAtivo)
        .map(f => ({
          idfuncionarios: f.idfuncionarios,
          nome: f.nome
        }))
      })
      .catch(showError)
    },

    async buscarExpedientes () {
      this.erroBusca = ''

      if (!this.filtro.inicio || !this.filtro.fim) {
        this.erroBusca = 'Informe data início e data fim.'
        return
      }

      if (moment(this.filtro.fim).isBefore(moment(this.filtro.inicio))) {
        this.erroBusca = 'A data fim não pode ser menor que a data início.'
        return
      }

      this.loadingBusca = true
      try {
        const res = await axios.get(`${baseApiUrl}/pontos`, {
          params: {
            idfunc: this.filtro.idfunc,
            inicio: this.filtro.inicio,
            fim: this.filtro.fim,
            status: 'ativos'
          }
        })

        const lista = []
        const dataIni = moment(this.filtro.inicio, 'YYYY-MM-DD')
        const dataFim = moment(this.filtro.fim, 'YYYY-MM-DD')

        ;(res.data || []).filter(this.isUsuarioAtivo).forEach(f => {
          if (this.filtro.idfunc && f.idfuncionarios !== this.filtro.idfunc) 
            return

            ;(f.horarios || []).forEach(h => {
              const dataISO = h.data || null
              if (!dataISO) 
                return

                const d = moment(dataISO, ['YYYY-MM-DD', moment.ISO_8601], true)
              if (!d.isValid()) 
                return
                if (d.isBefore(dataIni, 'day') || d.isAfter(dataFim, 'day')) 
                  return

                  lista.push({
                    key: `${f.idfuncionarios}-${h.idexpedientes || h.idexpediente || 'semid'}-${d.format('YYYY-MM-DD')}`,
                    idfuncionarios: f.idfuncionarios,
                    nome: f.nome,

                    idexpediente: h.idexpedientes || h.idexpediente || null,
                    data: d.format('YYYY-MM-DD'),

                    entrada: h.entrada,
                    saida_almoco: h.saida_almoco,
                    retorno: h.retorno,
                    saida: h.saida,

                    horas_trabalhadas: h.horastrabalhadas || this.formatoHoras(0),
                    carga_horaria_diaria: h.carga_horaria_diaria,
                    motivo: h.motivo,
                    descricao: h.descricao,
                    tipo: h.tipo,
                    status: h.status,
                    dia_semana: h.dia_semana,
                    cor: h.cor
                  })
              })
        })

        lista.sort((a, b) => a.data.localeCompare(b.data))
        this.resultados = lista
      } catch (e) {
        showError(e)
      } finally {
        this.loadingBusca = false
      }
    },

    formatoData (data) {
      if (data) 
        return moment(data, 'YYYY-MM-DD').format('DD/MM/YYYY')
    },

  abrirDialogoJustificativa (item) {
    this.justificativaItem = item
    this.dialogoJustificativa = true
  },

  save() {
    this.erroEdicao = ''
    const just = String(this.editJustificativa || '').trim()

    if (!just) {
      this.erroEdicao = 'Justificativa obrigatória para salvar a edição.'
      return
    }

    let dados = {}
    let id = null

    if (!this.isEmpty(this.editcampos)) {
      dados = { ...this.editcampos }
      id = dados.idexpediente || null
    } else if (!this.isEmpty(this.editponto)) {
      dados = { ...this.editponto }
      id = dados.idexpediente || null
    } else {
      this.$toasted.global.defaultError({ message: 'Nenhum dado para salvar.' })
      return
    }

  // ✅ regra do seu alteraponto.js
    dados.manual = true
    dados.justificativa_manual = just

    const metodoHttp = id ? 'put' : 'post'
    const url = id
    ? `${baseApiUrl}/alteraponto/${id}`
    : `${baseApiUrl}/alteraponto`

    axios[metodoHttp](url, dados)
    .then(() => {
      this.$toasted.global.defaultSuccess()
      this.loadCargaHoraria()
      this.reset()
    })
    .catch(showError)
  },

  salvarJustificativa () {
    if (this.texto) {
      this.texto.descricao = this.texto.descricao ? this.texto.descricao.trim() : ''
      this.texto.idfunc = this.justificativaItem.idfunc
      this.texto.status = true

      axios.put(`${baseApiUrl}/ausencias/${this.justificativaItem.idausencias}`, this.texto)
      .then(() => {
        this.$toasted.global.defaultSuccess()
        this.dialogoJustificativa = false
        this.justificativaTexto = ''
        this.justificativaItem = null
        this.texto = {}
        this.loadCargaHoraria()
        this.loadAusencias()
      })
      .catch(showError)
    } else {
      showError('Por favor, insira uma justificativa.')
    }
  },

  reset() {
    this.dialogEditarCampos = false
    this.dialogCampo = false
    this.editcampos = {}
    this.editponto = {}
    this.editJustificativa = ''
    this.erroEdicao = ''
  },


  formatoHoras (decimal) {
    const horas = Math.floor(decimal)
    const minutosDecimais = (decimal - horas) * 60
    const minutos = Math.floor(minutosDecimais)
    return `${String(horas).padStart(2, '0')}:${String(minutos).padStart(2, '0')}`
  },

  isEmpty (obj) {
    return Object.keys(obj).length === 0
  }
},

mounted () {
  this.loadCargaHoraria()
  this.loadAusencias()
  this.loadColaboradores()
}
}
</script>

<style scoped>
.domingo-row {
  background-color: #fff1f0 !important;
  color: #b71c1c !important;
}
.folga-row {
  background-color: #fff1c1 !important;
  color: #b71c1d !important;
}
.stats-card {
  padding: 20px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  text-align: center;
  background: white;
  transition: all 0.2s;
}
.stats-card:hover {
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}
.stats-number {
  font-size: 28px;
  font-weight: 500;
  color: #424242;
  margin-bottom: 8px;
}
.stats-label {
  font-size: 12px;
  color: #757575;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.professional-card {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
}
.professional-header {
  background: #fafafa;
  color: #424242;
  font-weight: 500;
  font-size: 16px;
  padding: 16px 24px;
}
.professional-subheader {
  background: #f5f5f5;
  color: #616161;
  font-weight: 500;
  font-size: 14px;
  padding: 12px 16px;
}
.expanded-content {
  background: #fafafa;
}
.professional-dialog {
  border-radius: 4px;
}
.professional-dialog-header {
  background: #424242;
  color: white;
  font-weight: 500;
  font-size: 16px;
  padding: 16px 24px;
}
</style>
